/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAlertWarning24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='#E6C005'
        fillRule='evenodd'
        d='M22.697 20.91A2.21 2.21 0 0120.788 22H3.212a2.21 2.21 0 01-1.909-1.09 2.195 2.195 0 01-.02-2.191c1.077-1.912 2.722-4.955 4.372-8.008C7.311 7.65 8.972 4.576 10.07 2.625a2.216 2.216 0 013.86 0c1.098 1.951 2.76 5.024 4.415 8.086 1.65 3.053 3.295 6.097 4.372 8.008a2.195 2.195 0 01-.02 2.191zm-20.121-.742a.739.739 0 00.636.364h17.576a.739.739 0 00.636-.364.729.729 0 00.006-.73c-1.07-1.901-2.703-4.922-4.345-7.959-1.664-3.078-3.338-6.173-4.442-8.134a.738.738 0 00-1.286 0c-1.104 1.96-2.778 5.056-4.442 8.134-1.642 3.037-3.275 6.058-4.345 7.96a.729.729 0 00.006.73zm9.982-5.964a.098.098 0 01.001.081l-1.636 3.617-.006.015a.717.717 0 001.27.64l2.583-5.203a.097.097 0 00-.062-.138l-3.032-.827a.097.097 0 01-.064-.054.1.1 0 010-.083l.658-1.395 1.03-2.184a.098.098 0 000-.082.1.1 0 00-.06-.054l-.619-.182-.826-.244a.097.097 0 00-.117.054l-2.27 5.027a.098.098 0 00.064.134l1.51.412 1.514.413c.027.008.05.027.062.053z'
      />
    </svg>
  );
}

export default SvgAlertWarning24;
